<template lang="">
  <div class="help-container">
    <ms-tooltip
      placement="bottom"
      effect="light"
      :hide-after="0"
    >
      <template #content>
        <span>{{ $t('Common.HelpTooltip') }}</span>
      </template>
      <img
        class="help outline-none"
        :src="help.src"
        :width="help.width"
        :height="help.height"
        @click.stop="onShowHelp"
      >
    </ms-tooltip>
  </div>
</template>

<script>
import MsTooltip from '@/components/tooltip'
import { useRoute } from 'vue-router'
// import { showHelp } from '@/common/common-fn'
import { emit, globalEvents } from '@/utils/event-bus'

export default {
  components: {
    MsTooltip
  },

  data () {
    return {
      help: {
        src: require('@/assets/icons/svg/user_info/ic_Help_20.svg'),
        width: 24,
        height: 24
      }
    }
  },

  setup () {
    const route = useRoute()

    const onShowHelp = () => {
      const helpID = route.meta.helpID

      helpID && emit(globalEvents.ShowHelp, helpID)
    }

    return {
      onShowHelp
    }
  }
}
</script>

<style lang="scss" scoped>
.help-container {
  height: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
</style>
